import { render, staticRenderFns } from "./LinkAddress.vue?vue&type=template&id=457bc608&scoped=true&"
import script from "./LinkAddress.vue?vue&type=script&lang=js&"
export * from "./LinkAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bc608",
  null
  
)

export default component.exports